import { apiFetchJson } from '@wundo/client/api.ts';
import type { PaginatedResponse } from '@/types/pagination.ts';
import type { ScheduledTask } from '@/types/scheduledTasks.ts';

/** What `/scheduled-tasks` narrows and pages by. All of it the server's work. */
export interface ScheduledTaskListParams {
  page?: number;
  limit?: number;
  userId?: string;
  organisationId?: string;
}

export async function listScheduledTasks(
  params: ScheduledTaskListParams = {},
): Promise<PaginatedResponse<ScheduledTask>> {
  const search = new URLSearchParams();

  if (params.page !== undefined) search.set('page', String(params.page));
  if (params.limit !== undefined) search.set('limit', String(params.limit));
  if (params.userId) search.set('user_id', params.userId);
  if (params.organisationId) search.set('organisation_id', params.organisationId);

  const query = search.toString();
  return apiFetchJson<PaginatedResponse<ScheduledTask>>(
    `/scheduled-tasks${query ? `?${query}` : ''}`,
  );
}
